import { useCallback, useEffect, useState } from 'react';
import api from '../api/api';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function ApplicationList() {
  const [apps, setApps] = useState([]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ nom: '', description: '', actif: true });
  const token = localStorage.getItem('token');

  const loadApps = useCallback(async () => {
    const res = await api.get('/applications', {
      headers: { Authorization: `Bearer ${token}` },
    });
    setApps(res.data);
  }, [token]);

  useEffect(() => {
    loadApps();
  }, [loadApps]);
const handleDelete = async (id) => {
  if (!window.confirm('Supprimer cette application ?')) return;

  try {
    await api.delete(`/applications/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    loadApps();
  } catch (error) {
    if (error.response && error.response.status === 409) {
      alert(error.response.data.message);
    } else {
      console.error("Erreur lors de la suppression:", error);
      alert("Une erreur est survenue lors de la suppression.");
    }
  }
};
  const handleEdit = (app) => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    setEditId(app.id);
    setForm({
      nom: app.nom,
      description: app.description,
      actif: app.actif,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    await api.put(`/applications/${editId}`, form, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setEditId(null);
    setForm({ nom: '', description: '', actif: true });
    loadApps();
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    await api.post('/applications', form, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setForm({ nom: '', description: '', actif: true });
    loadApps();
  };

  const toggleActive = async (app) => {
    await api.put(
      `/applications/${app.id}`,
      { ...app, actif: !app.actif },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    loadApps();
  };

  return (
    <>
      <Header />
      <main className="container">
        <h2>Applications</h2>

        <form onSubmit={editId ? handleUpdate : handleAdd}>
          <input
            placeholder="Nom"
            value={form.nom}
            onChange={(e) => setForm({ ...form, nom: e.target.value })}
            required
          />
          <input
            placeholder="Description"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />

          <label
            style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}
          >
            <input
              type="checkbox"
              checked={form.actif}
              onChange={(e) => setForm({ ...form, actif: e.target.checked })}
            />
            Application active
          </label>

          <button type="submit">{editId ? 'Modifier' : 'Ajouter'}</button>
          {editId && (
            <button
              type="button"
              onClick={() => {
                setEditId(null);
                setForm({ nom: '', description: '', actif: true });
              }}
            >
              Annuler
            </button>
          )}
        </form>
        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Description</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {apps.map((a) => (
                <tr key={a.id}>
                  <td>{a.nom}</td>
                  <td>{a.description}</td>
                  <td>
                    <span
                      onClick={() => toggleActive(a)}
                      style={{
                        display: 'inline-block',
                        width: '14px',
                        height: '14px',
                        borderRadius: '50%',
                        backgroundColor: a.actif ? '#4caf50' : '#f44336',
                        cursor: 'pointer',
                      }}
                      title={
                        a.actif
                          ? 'Active — cliquer pour désactiver'
                          : 'Inactive — cliquer pour activer'
                      }
                    />
                  </td>
                  <td>
                    <button onClick={() => handleEdit(a)}>✏️</button>
                    <button onClick={() => handleDelete(a.id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
      <Footer />
    </>
  );
}
